import { Module } from "wrapper6";
import Stickyfill from "stickyfilljs";

export default class Sticky extends Module {

    ready(app) {

        const ELEMENTS = document.querySelectorAll('.sticky');
        ELEMENTS.length > 0 && Stickyfill.add(ELEMENTS);

    }
}